import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, langNames } from "./translations";

const LangContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("sparko_lang") || "nl");

  useEffect(() => {
    localStorage.setItem("sparko_lang", lang);
    const dir = translations[lang].dir;
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
  }, [lang]);

  const t = translations[lang];
  const dir = t.dir;
  const value = { lang, setLang, t, dir, langNames };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

// helper: pick localized field from a doc (e.g. name_en/name_nl/name_ar)
export const loc = (doc, base, lang) => {
  if (!doc) return "";
  return doc[`${base}_${lang}`] || doc[`${base}_en`] || doc[base] || "";
};
